import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';


const _directiveDependencies = [];
const _controllerDependencies = ['$scope', 'UserNotificationsRestService', 'UserRestService'];

/**
 * @ngdoc directive
 * @name directives.controller.NotificationsController
 *
 * @description
 * email notifications form controller
 */
class NotificationsController {

    /**
     * @param  {any} $scope
     * @param  {any} UserNotificationsRestService
     */
    constructor($scope, UserNotificationsRestService, UserRestService) {

        this.$scope = $scope;
        this.MeRepository = MeRepository;
        this.UserNotificationsRestService = UserNotificationsRestService;
        this.user = MeRepository.getMyUser();
        this.$scope.notifications = angular.copy(this.user.attributes.notifications);
        this.$scope.loading = false;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.UserRestService = UserRestService;

    }

    /**
     * @ngdoc directive
     * @name directives.controller.NotificationsController#method
     * @methodOf directives.controller.NotificationsController
     *
     * @description
     * change the email notifications
    */
    changeNotifications() {

        // form model values === user email notifications values
        const formIsValid = !angular.equals(
            this.$scope.notifications,
            this.user.attributes.notifications,
        );

        const payload = {
            data: {
                attributes: {
                    notifications: this.$scope.notifications,
                },
                type: this.user.type,
                id: this.user.id,
            },
        };

        // if form has been changed
        if (formIsValid) {

            this.$scope.loading = true;
            // send the payload with the PUT update user method
            this.UserNotificationsRestService.update(this.user.id, payload).then(() => {

                // update the user repository
                this.UserRestService.getMeAsync().then((response) => {

                    this.$scope.loading = false;

                    this.MeRepository.update(response.data.data);

                    // update form with the latest user data email notifications from repository
                    this.user = this.MeRepository.getMyUser();
                    this.$scope.notifications = angular.copy(this.user.attributes.notifications);

                    Alert.success('cw.notifications.messages.success_extra_info');

                });

                Mixpanel.send('ConnectWeb Edit Notifications Click');

            }).then(null, () => {

                this.$scope.loading = false;
                Alert.error('cw.notifications.messages.error');

            });

        }

    }

}

/**
 * @ngdoc directive
 * @name directives.NotificationsDirective
 *
 * @description
 * email notifications form directive
 */
class NotificationsDirective {

    constructor() {

        this.template = require('./notifications.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push(($scope, UserNotificationsRestService, UserRestService) =>
            new NotificationsController($scope, UserNotificationsRestService, UserRestService));
        this.controller = _controllerDependencies;
        this.controllerAs = 'NotificationsCtrl';

    }

}

_directiveDependencies.push(() => new NotificationsDirective());


angular.module('directives')
    .directive('notifications', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/notifications/notifications.js